module.exports = __webpack_public_path__ + "img/Whats_in_your_pocket.684418ef.jpg";